"use strict"; // This gets overridden by rollup

import _classCallCheck from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/media/dev/a1f3111b-cf3b-4b8d-8080-52d4b51c231e6/dev/\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B/hackathons/DEFI/EncNft/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
var exportWordlist = false;
import { id } from "@ethersproject/hash";
import { defineReadOnly } from "@ethersproject/properties";
import { Logger } from "@ethersproject/logger";
import { version } from "./_version";
export var logger = new Logger(version);
export var Wordlist = /*#__PURE__*/function () {
  function Wordlist(locale) {
    _classCallCheck(this, Wordlist);

    logger.checkAbstract(this instanceof Wordlist ? this.constructor : void 0, Wordlist);
    defineReadOnly(this, "locale", locale);
  } // Subclasses may override this


  _createClass(Wordlist, [{
    key: "split",
    value: function split(mnemonic) {
      return mnemonic.toLowerCase().split(/ +/g);
    } // Subclasses may override this

  }, {
    key: "join",
    value: function join(words) {
      return words.join(" ");
    }
  }], [{
    key: "check",
    value: function check(wordlist) {
      var words = [];

      for (var i = 0; i < 2048; i++) {
        var word = wordlist.getWord(i);
        /* istanbul ignore if */

        if (i !== wordlist.getWordIndex(word)) {
          return "0x";
        }

        words.push(word);
      }

      return id(words.join("\n") + "\n");
    }
  }, {
    key: "register",
    value: function register(lang, name) {
      if (!name) {
        name = lang.locale;
      }
      /* istanbul ignore if */


      if (exportWordlist) {
        try {
          var anyGlobal = window;

          if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
            if (!anyGlobal._ethers.wordlists[name]) {
              defineReadOnly(anyGlobal._ethers.wordlists, name, lang);
            }
          }
        } catch (error) {}
      }
    }
  }]);

  return Wordlist;
}();